<template>
  <section>
    <div class="row">
      <div class="col">
        <p>When checked, the following notifications work with the Notify! Copilot Chrome-based browser extensions (e.g., Chrome, Edge).</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ul class="custom-list">
          <li v-for="item of notifications" :key="item.notificationType" class="custom-record">
            <input
              :id="`check_${item.notificationType}`"
              v-model="item.isNotification"
              type="checkbox"
              class="custom-checkbox"
              true-value="1"
              false-value="0"
              @change="notificationChanged(item)"
            />
            <span>{{ item.notificationTypeName }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'user-notifications',
  data() {
    return {
      notifications: []
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('users', ['userNotifications'])
  },
  methods: {
    ...mapActions('users', ['updateUserNotification', 'saveUserNotification']),
    init() {
      this.notifications = []
      if (this.userNotifications) {
        this.userNotifications.forEach(element => {
          if (parseInt(element.notificationType) !== 9999) {
            this.notifications.push(element)
          }
        })
      }
    },
    notificationChanged(item) {
      this.updateUserNotification(item)
      this.$emit('changed')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-notification-wrapper {
  padding: 10px;
}
.custom-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.custom-record {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/forms/user-notifications.vue